var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCirclesPattern = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 673,
    height: 449,
    viewBox: "0 0 673 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 560.965,
    cy: 112.061,
    r: 112,
    fill: "#8A8A8A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 560.965,
    cy: 336.061,
    r: 112,
    fill: "#5C5C5C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 336.965,
    cy: 112.061,
    r: 112,
    fill: "#8A8A8A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 336.965,
    cy: 336.061,
    r: 112,
    fill: "#8A8A8A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.965,
    cy: 112.061,
    r: 112,
    fill: "#8A8A8A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.965,
    cy: 336.061,
    r: 112,
    fill: "#5C5C5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.965 0.0608215C51.1093 0.0608215 0.96521 50.2049 0.96521 112.061H224.965C224.965 50.2049 174.821 0.0608215 112.965 0.0608215Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M560.965 224.061C499.109 224.061 448.965 274.205 448.965 336.061H672.965C672.965 274.205 622.821 224.061 560.965 224.061Z",
    fill: "#8A8A8A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCirclesPattern);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circles-pattern.7a3090ff5271a7e339c03aed86322baf.svg";